import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import {
  Tooltip,
  I18n,
} from 'components';

import { formatUnitString } from 'utils/formatString';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const BalanceTooltip = ({
  limit,
  arBalance,
  banRemainLimit,
  currency,
}) => (
  <Tooltip>
    <div className={cx('content')}>
      <div className={cx('calculationWrapper')}>
        <div className={cx('calculation')}>
          <div className={cx('amountWrapper')}>
            <div className={cx('amount')}>
              {formatUnitString(limit, currency)}
            </div>
            <I18n
              className={cx('hint')}
              path="home.accountState.expensesLimit"
            />
          </div>
          <div className={cx('amountWrapper')}>
            <div className={cx('amount')}>
              {formatUnitString(banRemainLimit + arBalance - limit, currency)}
            </div>
            <I18n
              className={cx('hint')}
              path="home.accountState.expensesByOffer"
            />
          </div>
          <div className={cx('amountWrapper')}>
            <div className={cx('amount')}>
              {formatUnitString(-arBalance, currency)}
            </div>
            <I18n
              className={cx('hint')}
              path="home.accountState.offerBalance"
            />
          </div>
        </div>
        <div className={cx('total')}>
          <div className={cx('amountWrapper')}>
            <div className={cx('amount')}>
              {formatUnitString(Math.abs(banRemainLimit), currency)}
            </div>
            <I18n
              className={cx('hint')}
              path={`home.accountState.${banRemainLimit > 0 ? 'restOfLimit' : 'limitIsExceeded'}`}
            />
          </div>
        </div>
      </div>
      <I18n
        className={cx('hint')}
        path="home.accountState.expensesLimitHint"
      />
    </div>
  </Tooltip>
);

BalanceTooltip.propTypes = {
  limit: PropTypes.number,
  arBalance: PropTypes.number,
  banRemainLimit: PropTypes.number,
  currency: PropTypes.string,
};

export default BalanceTooltip;
